/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./NonprofitPeers.css";
import { SHOW_ERRORS, ErrorPreview } from "./ErrorPreview";

// Nonprofit · "peers". Comparison is the engine of the marketplace: it is what
// makes a nonprofit publish better proof. Your own row is highlighted, and
// every column is a figure the public directory actually publishes.
class NonprofitPeers extends Component {
  render() {
    const vm = this.props.vm;
    const p = vm.peers;
    if (p.loading || p.error) {
      return (
        <div className="Marketplace-card Marketplace-status">{p.error ? vm.m.orgsError : vm.m.orgsLoading}</div>
      );
    }
    return (
      <div className="Marketplace-Peers">
        {SHOW_ERRORS && <ErrorPreview m={vm.m} className="Marketplace-card Marketplace-status" keys={["orgsError"]} />}
        <div className="Marketplace-card">
          <div className="Marketplace-cardHead">
            <span className="Marketplace-cardTitle">{vm.m.peersTitle}</span>
            <div className="Marketplace-chipRow">
              {p.filters.map((f) => (
                <div
                  className={"Marketplace-chip" + (f.active ? " Marketplace-chip--active" : "")}
                  onClick={f.pick}
                  key={f.id}
                >
                  {f.label}
                </div>
              ))}
            </div>
          </div>
          <div className="Marketplace-Peers-table">
            <div className="Marketplace-Peers-row Marketplace-Peers-row--head">
              <span />
              <span>{vm.m.colNonprofit}</span>
              <span className="Marketplace-right">{vm.m.colRaised}</span>
              <span className="Marketplace-right">{vm.m.colSupporters}</span>
              <span className="Marketplace-right">{vm.m.colShare}</span>
            </div>
            {p.rows.map((r) => (
              <div
                className={"Marketplace-Peers-row" + (r.you ? " Marketplace-Peers-row--you" : "")}
                key={r.id}
              >
                <span className="Marketplace-Peers-rank">{r.rank}</span>
                <div className="Marketplace-Peers-name">{r.name}</div>
                <span className="Marketplace-right Marketplace-Peers-month">{r.raisedLabel}</span>
                <span className="Marketplace-right Marketplace-Peers-cell">{r.supporters}</span>
                <span className="Marketplace-right Marketplace-Peers-cell">{r.sharePct}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="Marketplace-Peers-notes">
          {p.notes.map((n, i) => (
            <div className="Marketplace-card" key={i}>
              <div className="Marketplace-cardTitle">{n.tag}</div>
              <div className="Marketplace-Peers-noteTitle">{n.title}</div>
              <div className="Marketplace-Peers-noteBody">{n.body}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

NonprofitPeers.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default NonprofitPeers;
